import { useQuery } from "@apollo/client"
import { USER_LIST } from "../queries/userList"

interface UserListInput {
  search?: string
  isValid?: number
  countryId?: number
  regionId?: number
  categoryId?: number
  active?: number
  page?: number
  limit?: number
}

interface PersonCategory {
  name: string
}

interface Region {
  id: number
  name: string
  fullName: string
}

interface Country {
  name: string
  iso: string
}

interface Location {
  name: string
}

interface Address {
  countryId: number
  regionId: number
  locationId: number
  Region: Region
  Country: Country
  Location: Location
}

interface UserData {
  id: number
  name: string
  fullName: string
  code: string
  email: string
  phone?: string
  documentNumber?: string
  documentNumberType?: number
  avatar?: string
  urlAvatar?: string
  emailValid: number
  active: number
  urlEdit: string
  created: string
  birthday: string
  PersonCategory: PersonCategory
  Address?: Address
}

interface UserListResponse {
  UserList: {
    status: {
      success: boolean
      name: string
    }
    total: number
    pages: number
    Users: UserData[]
    Countries: Array<{ id: number; name: string }>
    Regions: Array<{ id: number; fullName: string; name: string }>
  }
}

export const useUserList = (input: UserListInput, { skip = false }) => {
  const { data, loading, error, refetch } = useQuery<UserListResponse>(USER_LIST, {
    variables: {
      UserListInput: {
        search: "",
        isValid: 3,
        countryId: 0,
        regionId: 0,
        categoryId: 0,
        active: 1,
        page: 1,
        limit: 20,
        ...input,
      },
    },
    errorPolicy: "all",
    skip,
  })

  return {
    users: data?.UserList?.Users || [],
    countries: data?.UserList?.Countries || [],
    regions: data?.UserList?.Regions || [],
    total: data?.UserList?.total || 0,
    pages: data?.UserList?.pages || 0,
    status: data?.UserList?.status,
    loading,
    error,
    refetch,
  }
}

export type { UserListInput, UserData }
